import queryString from 'query-string';
import { USERCENTER_TICKET } from '../../constant/CookieKeys'
import { openLink } from './link'


export default function to_casher(product_level) {
  console.log('前往收银台')
  setTimeout(() => {
    const param = {
      clocation: 1,
      source: gact.source,
      ftype: 5,
      product_level: product_level ? product_level : (gact.is_ott ? 2 : 1),
    }
    window.localStorage.removeItem(USERCENTER_TICKET); //清除掉用户中心的原有ticket,使用url中的ticket
    openLink(gact.config.h5_cashier + "?" + queryString.stringify(param));
  }, 100)
}
